// src/lib/groups.ts
// A store for predefined groups of emails that can be used for access control

export interface Group {
  id: string;
  name: string;
  description?: string;
  emails: string[];
}

/**
 * Predefined groups of emails
 * These are statically defined for now, but could be loaded from an API/database in the future
 */
export const predefinedGroups: Group[] = [
  {
    id: 'alicante',
    name: 'Alicante',
    description: 'Our New Energy members in Alicante',
    emails: [
      'msc@ournewenergy.com',
      'lsu@ournewenergy.com',
      'jpy@ournewenergy.com',
      'mar@ournewenergy.com'
    ]
  },
  {
    id: 'dev-team',
    name: 'Development Team',
    description: 'Development team members',
    emails: [
      'mark@aitanalabs.com',
      'msc@ournewenergy.com',
      'jpy@ournewenergy.com'
    ]
  },
  {
    id: 'external',
    name: 'External Users',
    description: 'External',
    emails: [
      'm@sunholo.com',
      'me@markedmondson.me'
    ]
  }
];

/**
 * Get all available predefined groups
 */
export function getAllGroups(): Group[] {
  return predefinedGroups;
}

/**
 * Get a group by its ID
 */
export function getGroupById(groupId: string): Group | undefined {
  return predefinedGroups.find(group => group.id === groupId);
}

/**
 * Get a list of all group names for UI display
 */
export function getAllGroupNames(): string[] {
  return predefinedGroups.map(group => group.name);
}

/**
 * Check if an email is in a specific group
 */
export function isEmailInGroup(email: string, groupId: string): boolean {
  const group = getGroupById(groupId);
  if (!group) return false;
  
  return group.emails.includes(email);
}

/**
 * Check if an email is in any of the specified groups
 */
export function isEmailInAnyGroup(email: string, groupIds: string[]): boolean {
  return groupIds.some(groupId => isEmailInGroup(email, groupId));
}

/**
 * Get all groups an email belongs to
 */
export function getGroupsForEmail(email: string): Group[] {
  return predefinedGroups.filter(group => 
    group.emails.includes(email)
  );
}